import {Component, OnInit} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";

export interface InstallationDialogInputModel {
  list: string[];
  title: string;
}

@Component({
  templateUrl: "./modify-installation-dialog.template.pug",
})
export class ModifyInstallationDialogComponent
  extends DialogComponent<InstallationDialogInputModel, string[]> implements OnInit {
  public error: Error;
  public projectName: string;
  public list: string[];
  public title: string;
  public listEdit: any[];

  static showDialog(
    dialogService: DialogService,
    list: string[],
    title: string,
  ): Observable<string[]> {
    return dialogService.addDialog(
      ModifyInstallationDialogComponent,
      {list: [...list], title},
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }

  public removeStep(index): void {
    this.listEdit.splice(index, 1);
  }

  public addStep(): void {
    this.listEdit.push({description: ""});
  }

  public moveUp(index): void {
    if (index - 1 < 0) return;
    const step = this.listEdit[index];
    this.listEdit[index] = this.listEdit[index - 1];
    this.listEdit[index - 1] = step;
  }

  public moveDown(index): void {
    if (index + 1 >= this.listEdit.length) return;
    const step = this.listEdit[index];
    this.listEdit[index] = this.listEdit[index + 1];
    this.listEdit[index + 1] = step;
  }

  cancel(): void {
    this.result = null;
    this.close();
  }

  save(): void {
    this.result = this.listEdit.filter(step => step.description).map(step => step.description);
    this.close();
  }

  ngOnInit(): void {
    this.listEdit = this.list.map(step => ({description: step}));
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }
}
